<template>
  <createActivity />
</template>

<script>
// 活动详情
import createActivity from './createActivity.vue'
export default {
  components: {
    createActivity
  },
}

</script>
